import { useState, useCallback, Fragment } from "react";
import Header from "../Header";
import Navbar from "../Navbar";

const TopBar = ({ hideMenuLogo }: { hideMenuLogo?: boolean }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const renderHeader = useCallback(() => {
    return <Header isMenuOpen={isMenuOpen} toggleMenu={toggleMenu}></Header>;
  }, [isMenuOpen]);

  const renderNavBar = useCallback(() => {
    return (
      <Navbar isMenuOpen={isMenuOpen} hideMenuLogo={hideMenuLogo}></Navbar>
    );
  }, [hideMenuLogo, isMenuOpen]);

  return (
    <Fragment>
      {renderHeader()}
      {renderNavBar()}
    </Fragment>
  );
};

export default TopBar;
